<script>
  import { StackList } from "creditdesign-svelte-components";
  import Company from "../Company/index.svelte";

  export let filteredCompanies;
  export let selectedCategoryOne = "";
  export let selectedCategoryTwo = "";
</script>

<style>
  .company {
    padding-top: var(--s1);
    padding-bottom: var(--s1);
    border-top: 1px solid var(--black-3);
  }

  .company:last-child {
    border-bottom: 1px solid var(--black-3);
  }
</style>

<StackList stackSpace="0">
  {#each filteredCompanies as companyData (companyData.name)}
    <li class="company">
      <Company {companyData} {selectedCategoryOne} {selectedCategoryTwo} />
    </li>
  {/each}
</StackList>
